


























import Vue from 'vue';
import UserTools from '@/components/UserTools.vue';

export default Vue.extend({
  name: 'App',
  components: {
    'user-tools': UserTools,
  },
});
